export interface ProductManagementErrorInterface {
  /**
   * @deprecated Errors often contain circular references and cannot be serialized. Only use this field if you require it.
   */
  error?: Error | unknown;
  code?: string;
  message: string;
  stack?: string;
}

export class ProductManagementError implements ProductManagementErrorInterface {
  constructor(
    public message: string,
    public stack?: string
  ) {}
}

export function isProductManagementError(error: unknown): error is ProductManagementErrorInterface {
  return !!(error as ProductManagementErrorInterface).error && !!(error as ProductManagementErrorInterface).message;
}
